export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (this.itemsPerPageAllNotAllowed()) {
            this.options = [
                {value: 10, label: 10},
                {value: 50, label: 50},
                {value: 100, label: 100},
                {value: 500, label: 500},
            ];
        } else {
            this.options = [
                {value: 10, label: 10},
                {value: 50, label: 50},
                {value: 100, label: 100},
                {value: 500, label: 500},
                {value: 1000000, label: 'global.filter.all'}
            ];
        }
    }

    itemsPerPageAllNotAllowed() {
        return this.$state.current.name == 'company.user-directories.directory-groups.all-accounts'
            || this.$state.current.name == 'company.user-directories.manage-group.accounts'
            || this.$state.current.name == 'company.user-directories.saaspass-users.all-users'
            || this.$state.current.name == 'company.user-directories.saaspass-users.administrators-developers'
            || this.$state.current.name == 'company.user-directories.saaspass-users.regular-saaspass-app-users'
            || this.$state.current.name == 'company.user-directories.saaspass-users.hard-token-users'
            || this.$state.current.name == 'company.user-directories.saaspass-users.sms-users'
            || this.$state.current.name == 'company.user-directories.saaspass-users.blocked-users'
    }

    get totalItemCount() {
        return this.stTable.tableState().pagination.totalItemCount;
    }


    get items() {
        return this.stTable.getFilteredCollection();
    }

    get itemsPerPage() {
        var itemsPerPage = (
            +localStorage.getItem(`items-per-page:${this.$state.current.name}`) ||
            +localStorage.getItem('items-per-page') ||
            100
                )
        return itemsPerPage > 500 && this.itemsPerPageAllNotAllowed() ? 500 : itemsPerPage;
    }

    set itemsPerPage(value) {
        this.deselectAllItems();
        if (!this.hasCustomItemsPerPage || !localStorage.getItem('items-per-page')) {
            localStorage.setItem('items-per-page', value);
        }
        if (this.hasCustomItemsPerPage) {
            localStorage.setItem(`items-per-page:${this.$state.current.name}`, value);
        }
    }

    deselectAllItems() {
        this.items.forEach(item => item.isSelected = false);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/pagination/sp-pagination.controller.js